import { FC, memo } from 'react'

import { Form } from 'brief-form'
import { LeaveConfirmation } from 'ui/components/LeaveConfirmation'
import { Panel } from 'ui/components/Panel'

import { ManageCompanyFormProps } from './ManageCompanyFormProps'
import {
  AccountDetails,
  AddressInformation,
  Description,
  MailingAddressInformation,
  Relationships,
  Tags
} from './components'

import * as SC from './styles'

export const ManageCompanyForm: FC<ManageCompanyFormProps> = memo((props) => {
  const { companyForDelete, companyData, Field, config, isSubmitting, isDirty } = props
  const { form } = companyData

  return (
    <Panel
      rounded
      shadowed
      title={form.id ? 'Edit Company Information' : 'Add Company Information'}
      collapsible={false}
      content-className={''}
    >
      <SC.Box>
        <LeaveConfirmation preventLeaving={!isSubmitting && isDirty && !companyForDelete}>
          <Form config={config}>
            <Relationships Field={Field} companyData={companyData} />
            <Description Field={Field} />
            <Tags Field={Field} />
            <AccountDetails
              Field={Field}
              isConsumerAccount={config.value.businessType === 'consumer_account'}
              companyData={companyData}
            />
            <SC.AddressWrapper>
              <AddressInformation Field={Field} config={config} />
              <MailingAddressInformation Field={Field} config={config} />
            </SC.AddressWrapper>
          </Form>
        </LeaveConfirmation>
      </SC.Box>
    </Panel>
  )
})
